/** Conservative measured-prefix evidence. A seek to the end cannot award consumption. */
export function createMeasuredPlaybackEvidence(durationMs) {
  let eligible = Number.isFinite(durationMs) && durationMs > 0;
  let prefix = 0,
    lastMedia = 0,
    lastWall = null,
    complete = false;
  function observe(position, wall, rate, playing) {
    if (
      !eligible ||
      !Number.isFinite(position) ||
      position < 0 ||
      !Number.isFinite(wall) ||
      !Number.isFinite(rate) ||
      rate < 0.5 ||
      rate > 3
    )
      return;
    if (!playing) {
      lastWall = null;
      return;
    }
    if (lastWall !== null) {
      const advance = position - lastMedia;
      if (
        advance < -200 ||
        advance > Math.max(0, wall - lastWall) * rate + 800 ||
        lastMedia > prefix + 800
      )
        eligible = false;
      else prefix = Math.max(prefix, Math.min(position, durationMs));
    } else if (position <= prefix + 800) prefix = Math.max(prefix, position);
    else eligible = false;
    lastMedia = position;
    lastWall = wall;
  }
  return {
    observe,
    pause() {
      lastWall = null;
    },
    discontinuity(position) {
      eligible = position <= 100;
      prefix = 0;
      lastMedia = Math.max(0, position);
      lastWall = null;
      complete = false;
    },
    ended(position, wall, rate, natural) {
      if (!natural) return false;
      observe(position, wall, rate, true);
      complete = eligible && position >= durationMs - 150 && prefix >= durationMs - 150;
      return complete;
    },
    get complete() {
      return complete;
    },
  };
}
